import React from 'react';
import Chart from 'react-apexcharts';
import { useNavigate } from 'react-router-dom';

const MostUsedAPIs = ({ apis, activeTab }) => {
    const navigate = useNavigate();
    const topApis = apis.slice(0, 10); // top 10

    const options = {
        chart: { type: 'bar', toolbar: { show: false } },
        plotOptions: {
            bar: { horizontal: true, borderRadius: 4 }
        },
        xaxis: { categories: topApis.map(api => api.path) },
        colors: ['#3498db'],
        dataLabels: { enabled: false }
    };

    const series = [{ name: 'Requests', data: topApis.map(api => api.calls) }];

    return (
        <div className="chart-card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3>Most Used APIs</h3>
                <button 
                    onClick={() => navigate('/user-api-auditlog', { state: { tab: activeTab } })} 
                    style={{
                        padding: '6px 14px',
                        backgroundColor: '#3498db',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '13px'
                    }}
                >
                    View Audit Log  <i className="fa fa-arrow-right" style={{ marginLeft: '5px' }} />
                </button>
            </div>
            <Chart options={options} series={series} type="bar" height={350} />
        </div>
    );
};

export default MostUsedAPIs;
